import { useState, useEffect, useMemo } from 'react'
import { func, string } from 'prop-types'
import { AdvancedMarker, APIProvider, InfoWindow, Map, Pin, useMapsLibrary } from '@vis.gl/react-google-maps'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const GeocodingComponent = ({ address, callback }) => {
  const [t] = useTranslation('sterilization')
  const geocodingLib = useMapsLibrary('geocoding')
  const [coordinates, setCoordinates] = useState(null)
  const [error, setError] = useState(null)
  const colors = { background: '#6bc242', borderColor: '#0a32c3', glyphColor: '#d6c11b' }
  const { mission } = useSelector(state => state.main)

  const geocoder = useMemo(() =>
    geocodingLib ? new geocodingLib.Geocoder() : null,
    [geocodingLib]
  )

  useEffect(() => {
    if (!geocoder || !address) return
    geocoder.geocode({ address: address }, (results, status) => {
      console.log(address, status, results)
      let mairie = null
      // eslint-disable-next-line no-unused-vars
      let zipCode = null
      results[0].address_components.forEach(component => {
        if (component.types.includes('locality') && component.types.includes('political')) {
          mairie = component.long_name.toLowerCase()
        }
        if (component.types.includes('postal_code')) {
          zipCode = component.long_name
        }
      })

      if (status === 'OK' && results[0] && mission.mairie.name.toLowerCase() === mairie) {
        const location = results[0].geometry.location
        setCoordinates({ lat: location.lat(), lng: location.lng() })
        setError(null)
      } else {
        setError(`Geocode was not successful for the following reason: ${status}`)
        setCoordinates(null)
        console.error(error)
      }
    })
  }, [geocoder, address])

  useEffect(() => {
    if (coordinates) {
      callback('coordinates', coordinates)
    }
  }, [coordinates])

  return (
    <Map
      style={{ width: '100%', height: '500px' }}
      defaultZoom={12}
      defaultCenter={mission.coordinates}
      fullscreenControl={true}
      gestureHandling="cooperative"
      mapId={`sterilization-call-preview-location`}
    >
      {coordinates
        ? <AdvancedMarker position={coordinates} >
          <Pin
            background={colors.background}
            borderColor={colors.borderColor}
            glyphColor={colors.glyphColor}
          />
        </AdvancedMarker>
        : <InfoWindow position={mission.coordinates} className='notification is-danger'>
          {t('messages.address_not_found')}
        </InfoWindow>}
    </Map>
  )
}

const GeocodeAddress = ({ address, callback = () => { } }) => {
  return (
    <APIProvider apiKey={import.meta.env.VITE_MAPS_KEY}>
      <GeocodingComponent address={address} callback={callback} />
    </APIProvider>
  )
}

GeocodeAddress.propTypes = {
  address: string,
  callback: func
}


GeocodingComponent.propTypes = {
  address: string,
  callback: func
}

export default GeocodeAddress
